<template>
  <nuxt-link
    :to="to"
    class="align-center group relative flex items-center my-1 text-gray-700 text-sm"
    :class="isCollapsed ? 'justify-center py-2' : 'px-3 py-3'"
    :aria-label="isCollapsed ? title : undefined"
  >
    <span :class="isCollapsed ? 'w-5' : 'mr-3 w-4'">
      <bs-icon :name="icon" class="relative w-full h-auto" />
    </span>
    <span v-if="!isCollapsed">{{ title }}</span>
    <side-nav-tooltip v-if="isCollapsed">{{ title }}</side-nav-tooltip>
  </nuxt-link>
</template>

<script lang="ts">
import { IconType } from "~/constants/icons";
import type { PropType } from "vue";
import { useSideNavStore } from "~/stores/sideNav";

export default defineComponent({
  props: {
    to: {
      type: String,
      default: "/",
    },
    icon: {
      type: String as PropType<IconType>,
      required: true,
    },
    title: {
      type: String,
      required: true,
    },
  },
  computed: {
    isCollapsed(): boolean {
      return useSideNavStore().isCollapsed;
    },
  },
});
</script>

<style scoped>
.nuxt-link-active {
  background: #4c51bf;
  color: #fff;
  font-weight: bold;
}
</style>
